// extracted by mini-css-extract-plugin
export default {"container":"LongTermMedicationIcon_container__Yvv5+","hidden":"LongTermMedicationIcon_hidden__-zdUH"};